import { render, staticRenderFns } from "./addGoodsWareHouse.vue?vue&type=template&id=39900800&scoped=true"
import script from "./addGoodsWareHouse.vue?vue&type=script&lang=js"
export * from "./addGoodsWareHouse.vue?vue&type=script&lang=js"
import style0 from "./addGoodsWareHouse.vue?vue&type=style&index=0&id=39900800&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39900800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39900800')) {
      api.createRecord('39900800', component.options)
    } else {
      api.reload('39900800', component.options)
    }
    module.hot.accept("./addGoodsWareHouse.vue?vue&type=template&id=39900800&scoped=true", function () {
      api.rerender('39900800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/addGoodsWareHouse/addGoodsWareHouse.vue"
export default component.exports